import { Box, ButtonBase, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import cx from 'classnames';
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useCreatePickingJobMutation, useGetFilterCountQuery } from "../../../newapi/pickingjob/pickingjobSlice";
import { useGetUsersSelectQuery } from "../../../newapi/user/userSlice";
import { useGetWarehousesSelectQuery } from "../../../newapi/warehouse/warehouseApiSlice";
import { tokens } from "../../../theme";
import { showToastMessagePostRequest, showToastMessageRequestError } from "../../../utils/toasts";
import SHModal from "../../theme/Modal/SHModal";
import ButtonGroup from "../../theme/buttons/ButtonGroup";
import Shbutton from "../../theme/buttons/Shbutton";
import { ShDropdownQuery } from "../../theme/dropdowns/Dropdown";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";
import { useSelector } from "react-redux";
const CustomMyComponent = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    return (
        <ButtonBase
            key={props.key}
            onClick={props.onClick}
            className={cx('',{
                'active': props.isSelected
            })}
            sx={{
                flexShrink:0,
                height:32,
                minWidth:300,
                width:1,
                pl:1.5,
                pr:0.5,
                textAlign:"left",
                display:"flex",
                justifyContent:'space-between',
                alignItems:"center",
                borderRadius:2,
                '&.active' : {
                    background: theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                    color: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                    fontWeight:"900",
                }
            }}
        >
            {props.option.name}

            {props.option.count && 
                <Box 
                    className={cx('',{
                        'active': props.isSelected
                    })}
                    sx={{
                        height:24,
                        background: theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                        display:"flex",
                        justifyContent:'center',
                        alignItems:"center",
                        px:1,
                        borderRadius:2,
                        '&.active' : {
                            background: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                            color: theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"],
                            fontWeight:"900",
                        }
                    }}
                >
                    {props.option.count}
                </Box>
            }
        </ButtonBase>
    )
}

const MCreateBatchFromOrders = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [orderAmount,setOrderAmount] = useState('');

    const {data: warehouses} = useGetWarehousesSelectQuery();
    const selectedWarehouse = useSelector(state => state.warehouse);

    const [optionMap, setOptionMap] = useState({
        'user': { 
            id:-1,
            name:t("no_selection")
        },
        'warehouse': {
            id:-1,
            name: t("no_selection")
        },
    })

    useEffect(() => {

        if (warehouses?.data.length === 1) {
            setOptionMap(optionMap => ({
                ...optionMap,
                warehouse: warehouses.data[0]
            }))
        }else {
            if(selectedWarehouse.activeId !== -1){
                setOptionMap(optionMap => ({
                    ...optionMap,
                    warehouse: {
                        id:selectedWarehouse.id,
                        name:selectedWarehouse.activeName
                    }
                }))
            }

        }
    }, [warehouses,selectedWarehouse])

    const getFilterIds = (options) => ({
        warehouseId: options.warehouse.id ?? -1,
    });

    const { data: warehouseData, isLoading:warehouseLoading,isfetching:warehouseFetching } = useGetWarehousesSelectQuery(undefined,{skip:!props.open});

    const { data: filterCount, isLoading, isFetching } = useGetFilterCountQuery(getFilterIds(optionMap),{skip:!props.open});

    const [createPickingJob,{isLoading: createLoading}] = useCreatePickingJobMutation();

    const handleClose = () => {
        props.handleClose();
        setOptionMap(prev => ({
            ...prev,
            user : { 
                id:-1,
                name:t("no_selection")
            },
        }))
    }
      
    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    useEffect(() => {
        if(filterCount?.orderCount < orderAmount) {
            setOrderAmount(filterCount.orderCount);

            toast.warning(t("new_max_message"), {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    },[filterCount])

    useEffect(() => {
        if(!warehouseFetching && !warehouseLoading && warehouseData){
            if(warehouseData.data.length === 1) {
                setOptionMap(optionMap => ({
                    ...optionMap,
                    warehouse: warehouseData.data[0],
                }))
            }
        }
    },[warehouseData,warehouseFetching,warehouseLoading])

    const [userError,setUserError] = useState(null);
    const [warehouseError,setWarehouseError] = useState(null);

    const handleSave = () => {
        if (createLoading) {
            return;
        }
        setUserError(null);
        setWarehouseError(null);

        if(optionMap.user.id === -1) {
            setUserError(t("user_required"));
            return;
        }

        if(optionMap.warehouse.id === -1) {
            setWarehouseError(t("warehouse_required"));
            return;
        }

        createPickingJob({
            ...getFilterIds(optionMap),
            user: optionMap.user,
            orderIds:props.selectedItems,
        })
        .unwrap()
        .then(res => {
            showToastMessagePostRequest(t, res);
            props.setSelectedItems([]);
            handleClose();
        })
        .catch(err => {
            showToastMessageRequestError(t("create_failed"),t, err);
        })   
    }


    return(
        <SHModal
            open={props.open}
            onClose={handleClose}
            sx={{
                body:{
                    width:450,
                }
            }}
        >
            <Box 
                sx={{
                    paddingY:3,
                    paddingX:3,
                    display:"flex",
                    flexDirection:"column",
                }}
            >
                <Subheading textAlign="center">{t("create_batch")}</Subheading>
                <Box
                    sx={{
                        mt:2,
                        borderRadius: 5,
                        height:40,
                        display:'flex',
                        alignItems:"center",
                        justifyContent:'space-between',
                        pl:2,
                        pr:0.5,
                        // background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0]

                        background:theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                    }}
                >
                    <Text>{t("amount_of_orders_selected")}</Text>
                    <Box
                        sx={{
                            height:32,
                            width:32,
                            borderRadius:4,
                            display:'flex',
                            alignItems:"center",
                            justifyContent:'center',
                            background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100]
                        }}
                    >
                        <Text bold>{props.selectedItems.length}</Text>
                    </Box>
                </Box>
            </Box>

            {/* BODY */}
            <Box
                sx={{
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    padding:3,
                    pb:1,
                    borderTopLeftRadius:16,
                    borderTopRightRadius:16,
                    display:"flex",
                    flexDirection:"column",
                }}
            >
                <ShDropdownQuery
                    name="name"
                    onChange={(selected,object) => {
                        setOptionMap(optionMap => ({
                            ...optionMap,
                            user: selected !== null ? object : {
                                id:-1,
                                name: t("no_selection")
                            }
                        }))
                    }}
                    valueKey={"id"}
                    dataKey={null}
                    shComponent={<CustomMyComponent/>}
                    selected={optionMap.user.id}
                    content={useGetUsersSelectQuery}
                    closeOnSelection
                >
                    {({anchorEl,onClick}) => (
                        <ButtonBase
                            onClick={onClick}
                            sx={{
                                height:32,
                                borderRadius:5,
                                background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                                display:"flex",
                                alignItems:'center',
                                px:0.5,
                                position:'relative',
                                "&:before" : {
                                    content:'""',
                                    position:'absolute',
                                    borderRadius:5,
                                    left:0,
                                    top:0,
                                    width:1,
                                    height:1,
                                    background:userError ? colors.red[100] : theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                                    // border:`1px solid ${colors.grey[100]}`,
                                    boxShadow:`0px 2px 4px ${colors.grey[200]}`,
                                }
                            }}
                        >

                            <Box
                                sx={{
                                    height:24,
                                    lineHeight:"24px",
                                    background:userError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400],
                                    borderRadius:3,
                                    border: `1px solid ${userError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400]}`,
                                    width:110,
                                    textAlign:"center",
                                    fontSize:14,
                                    fontWeight:"bold",
                                    color:theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"],
                                }}
                            >
                                {t("user")}

                            </Box>
                            <Box
                                sx={{
                                    flex:1,
                                    ml:1.5,
                                    textAlign:"left",
                                }}
                            >
                                <Text bold >
                                    {optionMap.user?.name}
                                </Text>
                            </Box>
                            <Box
                                sx={{
                                    display:'flex',
                                    gap:1.5,
                                    alignItems:'center',
                                }}
                            >
                                <Text italic bold variant={userError ? "red" : theme.palette.mode === "dark" ? "blue" :  "primary"}>
                                    {t("required")}
                                </Text>
                                <Box
                                    sx={{
                                        height:24,
                                        width:24,
                                        borderRadius:3,
                                        display:"flex",
                                        alignItems:'center',
                                        justifyContent:"center",
                                        background:userError ? colors.red[100] :  theme.palette.mode === "dark" ? colors.blue[100] :  colors.primary[100],
                                        border: `1px solid ${userError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400]}`,
                                        color: userError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400],
                                    }}
                                >
                                    <KeyboardArrowDownIcon/>

                                </Box>
                            </Box>

                        </ButtonBase>
                    )}
                </ShDropdownQuery>

                <ShDropdownQuery
                    onChange={(selected,object) => {
                        setOptionMap(optionMap => ({
                            ...optionMap,
                            warehouse: selected !== null ? object : {
                                id:-1,
                                name: t("no_selection")
                            }
                        }))
                    }}
                    valueKey={"id"}
                    dataKey={"data"}
                    shComponent={<CustomMyComponent/>}
                    selected={optionMap.warehouse.id}
                    content={useGetWarehousesSelectQuery}
                    closeOnSelection
                >
                    {({anchorEl,onClick}) => (
                        <ButtonBase
                            onClick={onClick}
                            sx={{
                                mt:2,
                                height:32,
                                borderRadius:5,
                                background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                                display:"flex",
                                alignItems:'center',
                                px:0.5,
                                position:'relative',
                                "&:before" : {
                                    content:'""',
                                    position:'absolute',
                                    borderRadius:5,
                                    left:0,
                                    top:0,
                                    width:1,
                                    height:1,
                                    background:warehouseError ? colors.red[100] : theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                                    // border:`1px solid ${colors.grey[100]}`,
                                    boxShadow:`0px 2px 4px ${colors.grey[200]}`,
                                }
                            }}
                        >

                            <Box
                                sx={{
                                    height:24,
                                    lineHeight:"24px",
                                    background:warehouseError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400],
                                    borderRadius:3,
                                    border: `1px solid ${warehouseError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400]}`,
                                    width:110,
                                    textAlign:"center",
                                    fontSize:14,
                                    fontWeight:"bold",
                                    color:theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"],
                                }}
                            >
                                {t("warehouse")}

                            </Box>
                            <Box
                                sx={{
                                    flex:1,
                                    ml:1.5,
                                    textAlign:"left",
                                }}
                            >
                                <Text bold >
                                    {optionMap.warehouse?.name}
                                </Text>
                            </Box>
                            <Box
                                sx={{
                                    display:'flex',
                                    gap:1.5,
                                    alignItems:'center',
                                }}
                            >
                                <Text italic bold variant={warehouseError ? "red" : theme.palette.mode === "dark" ? "blue" :  "primary"}>
                                    {t("required")}
                                </Text>
                                <Box
                                    sx={{
                                        height:24,
                                        width:24,
                                        borderRadius:3,
                                        display:"flex",
                                        alignItems:'center',
                                        justifyContent:"center",
                                        background:warehouseError ? colors.red[100] :  theme.palette.mode === "dark" ? colors.blue[100] :  colors.primary[100],
                                        border: `1px solid ${warehouseError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400]}`,
                                        color: warehouseError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400],
                                    }}
                                >
                                    <KeyboardArrowDownIcon/>

                                </Box>
                            </Box>

                        </ButtonBase>
                    )}
                </ShDropdownQuery>
                
            </Box>
            <Box
                component="footer"
                sx={{
                    
                    display:"block",
                    width:1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    paddingRight:3,
                    zIndex:1058,
                    position:"relative",
                    paddingTop:2,
                    background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >
                <Shbutton isCancel={true} className={"always-visible"} onClick={handleClose} color="primary" variant="text" startIcon={<ArrowRightAltIcon/>}>{t("cancel")}</Shbutton>
                <ButtonGroup version={2}>
                    <Shbutton 
                    className={"group-btn"} 
                    color={theme.palette.mode === "dark" ? "blue" : "primary"}
                    variant="contained" 
                    onClick={() => handleSave()}
                    isLoading={createLoading}
                >
                    {t("add")}
                </Shbutton>
                </ButtonGroup>
            </Box>
        </SHModal>
    )
}

export default MCreateBatchFromOrders;
